// import React, { useState, useRef, useEffect } from 'react';
// import './DocumentActions.css';

// const DocumentActions = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const handlePrint = () => {
//     // window.print();
//     setIsOpen(false);
//   };

//   const handleDownload = () => {
//     console.log('Download clicked');
//     setIsOpen(false);
//   };

//   return (
//     <div className="document-actions" ref={dropdownRef}>
//       <div className="icon-button" onClick={() => setIsOpen(!isOpen)}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//             className='gear-icon'
//             style={{transform: isOpen ? "rotate(16deg)" : "rotate(0deg)",}}
//           >
//             <path d="M22.0606 12.2298L22.0585 11.7898C22.0558 11.2594 21.8426 10.7517 21.4656 10.3785C21.0887 10.0053 20.5789 9.79715 20.0485 9.79979L19.8685 9.80069C19.5178 9.80208 19.1729 9.71121 18.8684 9.53721C18.5638 9.3632 18.3104 9.11218 18.1336 8.80932L17.8814 8.38057C17.7044 8.07741 17.6102 7.73298 17.6085 7.38191C17.6068 7.03085 17.6974 6.6855 17.8715 6.38059L17.9507 6.2302C18.2132 5.76995 18.2823 5.22437 18.1429 4.71322C18.0034 4.20208 17.6669 3.76713 17.2071 3.50386L16.826 3.28576C16.3658 3.02331 15.8202 2.95421 15.3091 3.09362C14.7979 3.23303 14.363 3.56956 14.0997 4.02934L14.0005 4.17984C13.8275 4.48298 13.5781 4.73557 13.2773 4.9125C12.9764 5.08943 12.6345 5.18455 12.2855 5.18839L11.7755 5.19093C11.4231 5.19409 11.0761 5.10406 10.7696 4.92998C10.4632 4.7559 10.2082 4.50394 10.0305 4.19961L9.93977 4.05006C9.67193 3.59292 9.23366 3.26074 8.72115 3.12642C8.20864 2.99211 7.66378 3.06664 7.20616 3.33366L6.82726 3.55555C6.37013 3.82338 6.03794 4.26166 5.90363 4.77417C5.76932 5.28668 5.84385 5.83154 6.11087 6.28915L6.19161 6.43875C6.36866 6.74191 6.46279 7.08634 6.46454 7.4374C6.46629 7.78847 6.37559 8.13382 6.20157 8.43873L5.95372 8.86997C5.77987 9.17457 5.52897 9.42811 5.2262 9.60514C4.92343 9.78216 4.57944 9.87646 4.22872 9.87857L4.04872 9.87946C3.51829 9.8821 3.01064 10.0953 2.63744 10.4723C2.26424 10.8492 2.05606 11.359 2.0587 11.8894L2.06089 12.3294C2.06353 12.8598 2.27678 13.3675 2.65371 13.7407C3.03065 14.1139 3.5404 14.3221 4.07083 14.3194L4.25083 14.3185C4.60155 14.3171 4.94647 14.408 5.25099 14.582C5.5555 14.756 5.80891 15.007 5.98578 15.3099L6.23792 15.7386C6.41497 16.0418 6.5091 16.3862 6.51085 16.7373C6.5126 17.0884 6.4219 17.4337 6.24788 17.7386L6.16863 17.889C5.90618 18.3493 5.83708 18.8948 5.97649 19.406C6.1159 19.9171 6.45243 20.3521 6.91221 20.6153L7.3033 20.8334C7.76355 21.0958 8.30913 21.1649 8.82028 21.0255C9.33142 20.8861 9.76637 20.5496 10.0296 20.0898L10.1089 19.9394C10.2836 19.6333 10.536 19.3788 10.8407 19.2017C11.1454 19.0246 11.4915 18.9311 11.8439 18.9308L12.3439 18.9283C12.6963 18.9251 13.0433 19.0151 13.3497 19.1892C13.6561 19.3633 13.9111 19.6153 14.0888 19.9196L14.1796 20.0691C14.4474 20.5263 14.8857 20.8585 15.3982 20.9928C15.9107 21.1271 16.4556 21.0526 16.9132 20.7855L17.2921 20.5637C17.7492 20.2958 18.0814 19.8575 18.2157 19.345C18.35 18.8325 18.2755 18.2877 18.0085 17.8301L17.9277 17.6805C17.7507 17.3773 17.6566 17.0329 17.6548 16.6818C17.6531 16.3307 17.7438 15.9854 17.9178 15.6805L18.1656 15.2492C18.3395 14.9446 18.5904 14.6911 18.8931 14.5141C19.1959 14.337 19.5399 14.2427 19.8906 14.2406L20.0706 14.2397C20.6011 14.2371 21.1087 14.0239 21.4819 13.6469C21.8551 13.27 22.0633 12.7602 22.0606 12.2298Z" stroke={isOpen ? "#094C80" : "black"} stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M9.05969 12.0745C9.06794 13.7314 10.4178 15.0678 12.0746 15.0596C13.7314 15.0513 15.0679 13.7015 15.0596 12.0447C15.0514 10.3878 13.7015 9.0514 12.0447 9.05965C10.3879 9.0679 9.05144 10.4177 9.05969 12.0745Z" stroke={isOpen ? "#094C80" : "black"} stroke-linecap="round" stroke-linejoin="round"/>
//           </svg>
//       </div>

//       {isOpen && (
//         <div className="dropdown-menu">
//           <button className="menu-item  common-text ftw-4 dk-gray" onClick={handlePrint}>
//           <svg className='menu-item-icon' xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
//             <path d="M13.5 22H7C6.73478 22 6.48043 21.8946 6.29289 21.7071C6.10536 21.5196 6 21.2652 6 21V15C6 14.7348 6.10536 14.4804 6.29289 14.2929C6.48043 14.1054 6.73478 14 7 14H17C17.2652 14 17.5196 14.1054 17.7071 14.2929C17.8946 14.4804 18 14.7348 18 15V15.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M16 19L18 21L22 17" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M6 9V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V9" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//           </svg>
//             Print
//           </button>
//           <button className="menu-item  common-text ftw-4 dk-gray" onClick={handleDownload}>
//           <svg className='menu-item-icon' xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
//             <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M7 10L12 15L17 10" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//             <path d="M12 15V3" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//           </svg>
//             Download
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DocumentActions;

import React, { useState, useRef, useEffect } from "react";
import "./DocumentActions.css";
import { useTranslation } from "react-i18next";

const DocumentActions = ({
  onPrint,
  printText = "",
  onDownload,
  onDuplicate,
}) => {
  // ✅ props added
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePrint = () => {
    if (onPrint) onPrint(); // ✅ trigger parent function
    setIsOpen(false);
  };

  const handleDownload = () => {
    if (onDownload) onDownload(); // ✅ trigger parent function
    setIsOpen(false);
  };

  const handleDuplicate = () => {
    if (onDuplicate) onDuplicate(); // ✅ trigger parent function
    setIsOpen(false);
  };

  return (
    <div className="document-actions" ref={dropdownRef}>
      <div className="icon-button" onClick={() => setIsOpen(!isOpen)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="gear-icon"
          style={{ transform: isOpen ? "rotate(16deg)" : "rotate(0deg)" }}
        >
          <path
            d="M22.0606 12.2298L22.0585 11.7898C22.0558 11.2594 21.8426 10.7517 21.4656 10.3785C21.0887 10.0053 20.5789 9.79715 20.0485 9.79979L19.8685 9.80069C19.5178 9.80208 19.1729 9.71121 18.8684 9.53721C18.5638 9.3632 18.3104 9.11218 18.1336 8.80932L17.8814 8.38057C17.7044 8.07741 17.6102 7.73298 17.6085 7.38191C17.6068 7.03085 17.6974 6.6855 17.8715 6.38059L17.9507 6.2302C18.2132 5.76995 18.2823 5.22437 18.1429 4.71322C18.0034 4.20208 17.6669 3.76713 17.2071 3.50386L16.826 3.28576C16.3658 3.02331 15.8202 2.95421 15.3091 3.09362C14.7979 3.23303 14.363 3.56956 14.0997 4.02934L14.0005 4.17984C13.8275 4.48298 13.5781 4.73557 13.2773 4.9125C12.9764 5.08943 12.6345 5.18455 12.2855 5.18839L11.7755 5.19093C11.4231 5.19409 11.0761 5.10406 10.7696 4.92998C10.4632 4.7559 10.2082 4.50394 10.0305 4.19961L9.93977 4.05006C9.67193 3.59292 9.23366 3.26074 8.72115 3.12642C8.20864 2.99211 7.66378 3.06664 7.20616 3.33366L6.82726 3.55555C6.37013 3.82338 6.03794 4.26166 5.90363 4.77417C5.76932 5.28668 5.84385 5.83154 6.11087 6.28915L6.19161 6.43875C6.36866 6.74191 6.46279 7.08634 6.46454 7.4374C6.46629 7.78847 6.37559 8.13382 6.20157 8.43873L5.95372 8.86997C5.77987 9.17457 5.52897 9.42811 5.2262 9.60514C4.92343 9.78216 4.57944 9.87646 4.22872 9.87857L4.04872 9.87946C3.51829 9.8821 3.01064 10.0953 2.63744 10.4723C2.26424 10.8492 2.05606 11.359 2.0587 11.8894L2.06089 12.3294C2.06353 12.8598 2.27678 13.3675 2.65371 13.7407C3.03065 14.1139 3.5404 14.3221 4.07083 14.3194L4.25083 14.3185C4.60155 14.3171 4.94647 14.408 5.25099 14.582C5.5555 14.756 5.80891 15.007 5.98578 15.3099L6.23792 15.7386C6.41497 16.0418 6.5091 16.3862 6.51085 16.7373C6.5126 17.0884 6.4219 17.4337 6.24788 17.7386L6.16863 17.889C5.90618 18.3493 5.83708 18.8948 5.97649 19.406C6.1159 19.9171 6.45243 20.3521 6.91221 20.6153L7.3033 20.8334C7.76355 21.0958 8.30913 21.1649 8.82028 21.0255C9.33142 20.8861 9.76637 20.5496 10.0296 20.0898L10.1089 19.9394C10.2836 19.6333 10.536 19.3788 10.8407 19.2017C11.1454 19.0246 11.4915 18.9311 11.8439 18.9308L12.3439 18.9283C12.6963 18.9251 13.0433 19.0151 13.3497 19.1892C13.6561 19.3633 13.9111 19.6153 14.0888 19.9196L14.1796 20.0691C14.4474 20.5263 14.8857 20.8585 15.3982 20.9928C15.9107 21.1271 16.4556 21.0526 16.9132 20.7855L17.2921 20.5637C17.7492 20.2958 18.0814 19.8575 18.2157 19.345C18.35 18.8325 18.2755 18.2877 18.0085 17.8301L17.9277 17.6805C17.7507 17.3773 17.6566 17.0329 17.6548 16.6818C17.6531 16.3307 17.7438 15.9854 17.9178 15.6805L18.1656 15.2492C18.3395 14.9446 18.5904 14.6911 18.8931 14.5141C19.1959 14.337 19.5399 14.2427 19.8906 14.2406L20.0706 14.2397C20.6011 14.2371 21.1087 14.0239 21.4819 13.6469C21.8551 13.27 22.0633 12.7602 22.0606 12.2298Z"
            stroke={isOpen ? "#094C80" : "black"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.05969 12.0745C9.06794 13.7314 10.4178 15.0678 12.0746 15.0596C13.7314 15.0513 15.0679 13.7015 15.0596 12.0447C15.0514 10.3878 13.7015 9.0514 12.0447 9.05965C10.3879 9.0679 9.05144 10.4177 9.05969 12.0745Z"
            stroke={isOpen ? "#094C80" : "black"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          {onPrint && (
            <button
              className="menu-item common-text ftw-4 dk-gray"
              onClick={handlePrint}
            >
              <svg
                className="menu-item-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M13.5 22H7C6.73478 22 6.48043 21.8946 6.29289 21.7071C6.10536 21.5196 6 21.2652 6 21V15C6 14.7348 6.10536 14.4804 6.29289 14.2929C6.48043 14.1054 6.73478 14 7 14H17C17.2652 14 17.5196 14.1054 17.7071 14.2929C17.8946 14.4804 18 14.7348 18 15V15.5"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 19L18 21L22 17"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V13"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 9V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V9"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {t(printText) || t("Print")}
            </button>
          )}
          {onDownload && (
            <button
              className="menu-item common-text ftw-4 dk-gray"
              onClick={handleDownload}
            >
              <svg
                className="menu-item-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 10L12 15L17 10"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 15V3"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {t("Download")}
            </button>
          )}
          {onDuplicate && (
            <button
              className="menu-item common-text ftw-4 dk-gray"
              onClick={handleDuplicate}
            >
              <svg
                className="menu-item-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 8H10C8.89543 8 8 8.89543 8 10V20C8 21.1046 8.89543 22 10 22H20C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8Z"
                  stroke="black"
                  stroke-width="0.83"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4"
                  stroke="black"
                  stroke-width="0.83"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {t("Duplicate")}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DocumentActions;
